import { ChevronDownIcon, ChevronUpIcon } from "@lifesg/react-icons";
import { lowercaseAndHyphen } from "app/utils/strings";
import React from "react";
import "./Category.scss";

interface IProps {
	title: string;
	content: string | JSX.Element | JSX.Element[];
	isOpen?: boolean;
	largeTitle?: boolean;
	onOpenChange: () => void;
}

export interface IMinimalQuestionAnswer {
	question: string;
	answer: string | JSX.Element | JSX.Element[];
}

export interface IQuestionAnswer extends IMinimalQuestionAnswer {
	category: string;
	index: number;
}

export const insertCategoryAndIndex = (
	questionAndAnswer: IMinimalQuestionAnswer[],
	category: string,
): IQuestionAnswer[] => {
	const questionsWithCategory = questionAndAnswer.map((qna: IMinimalQuestionAnswer, index: number) => {
		return { ...qna, category, index };
	});
	return questionsWithCategory;
};

const QnACategory = (props: IProps): JSX.Element => {
	const formattedName: string = lowercaseAndHyphen(props.title);
	const iconClassName = "category__qna__expand-icon icon";

	const DownIcon = (): JSX.Element => (
		<div className={iconClassName}>
			<ChevronDownIcon />
		</div>
	);

	const UpIcon = (): JSX.Element => (
		<div className={iconClassName}>
			<ChevronUpIcon />
		</div>
	);

	const icon = props.isOpen ? <UpIcon /> : <DownIcon />;

	return (
		<div className={`category__qna ${props.isOpen ? "qna-category-open" : "qna-category-close"}`}>
			<button id={formattedName} className="category__qna__header" onClick={props.onOpenChange}>
				{props.largeTitle ? (
					<h4 className="category__qna__title__large">{props.title}</h4>
				) : (
					<div className="category__qna__title">{props.title}</div>
				)}
				{icon}
			</button>
			{props.isOpen && (
				<div id={`items-${formattedName}`} className="category__qna__container">
					{props.content}
				</div>
			)}
		</div>
	);
};

export default QnACategory;
